import { render, staticRenderFns } from "./buy-passes.vue?vue&type=template&id=675164b6"
import script from "./buy-passes.vue?vue&type=script&lang=js"
export * from "./buy-passes.vue?vue&type=script&lang=js"
import style0 from "./buy-passes.vue?vue&type=style&index=0&id=675164b6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675164b6')) {
      api.createRecord('675164b6', component.options)
    } else {
      api.reload('675164b6', component.options)
    }
    module.hot.accept("./buy-passes.vue?vue&type=template&id=675164b6", function () {
      api.rerender('675164b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buy-passes.vue"
export default component.exports